import { render, staticRenderFns } from "./actions-data.vue?vue&type=template&id=478254f0"
import script from "./actions-data.vue?vue&type=script&lang=js"
export * from "./actions-data.vue?vue&type=script&lang=js"
import style0 from "./actions-data.vue?vue&type=style&index=0&id=478254f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports